// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { RatingModule } from 'libraries/component/rating/rating.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { RoomModule } from 'libraries/hotel/components/room/room.module';
import { MenuDetailsModule } from 'libraries/hotel/components/menu-details/menu-details.module';
import { DescriptionModule } from 'libraries/hotel/components/description/description.module';
import { LanguageService } from 'libraries/service/language/language.service';
import { InformationsModule } from 'libraries/hotel/components/informations/informations.module';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { HotelResumeModule } from 'libraries/hotel/components/hotel-resume/hotel-resume.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        RatingModule,
        DatePipeModule,
        PricePipesModule,
        PricePipeModule,
        LoaderModule,
        BtnModule,
        RoomModule,
        MenuDetailsModule,
        DescriptionModule,
        InformationsModule,
        HotelResumeModule,
        FontAwesomeModule,
    ],
    providers: [
        LanguageService,
        QuotationService,
        BreadcrumbService,
    ],
})
export class SharedModule {
}
